import { find } from './dom';

// Meni otvara dugme bez skripte (popover); skripta ga zatvara posle izbora, jer link na sidro iste stranice (/#kako) ne
// učitava novu stranicu koja bi ga sklonila.
export function enhanceMenu(): void {
  const menu = find(document, 'menu', HTMLElement);
  $(menu).on('click', 'a', () => menu.hidePopover());
}
